export const dateFormatter = (date: any, output: "input" | "display") => {
    if (!date) return "";

    // Handle Date object
    if (date instanceof Date && !isNaN(date.getTime())) {
        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, "0");
        const dd = String(date.getDate()).padStart(2, "0");

        return output === "input"
            ? `${yyyy}-${mm}-${dd}`
            : `${dd}.${mm}.${yyyy}`;
    }

    let str = String(date).trim();

    // normalize separators (., / → -)
    str = str.replace(/[./]/g, "-");

    const parts = str.split("-");
    if (parts.length !== 3) return "";

    let [a, b, c] = parts;

    let yyyy: string, mm: string, dd: string;

    if (a.length === 4) {
        // yyyy-mm-dd
        yyyy = a;
        mm = b;
        dd = c;
    } else if (c.length === 4) {
        // dd-mm-yyyy
        dd = a;
        mm = b;
        yyyy = c;
    } else {
        return "";
    }

    mm = mm.padStart(2, "0");
    dd = dd.padStart(2, "0");

    return output === "input"
        ? `${yyyy}-${mm}-${dd}` // for <input type="date" />
        : `${dd}.${mm}.${yyyy}`; // for display/storage
};